"use client"
import { MOCK_ALL_APIS } from "@/constants"
import { SignIn } from "./signIn.interface"
import { signIn } from "./signIn"
import { signInMock } from "./signIn.mock"

const resolvedAction: SignIn = MOCK_ALL_APIS ? signInMock : signIn
export { resolvedAction as signIn }
